import { render } from "./summary-stt.vue?vue&type=template&id=00a07e5a&ts=true"
import script from "./summary-stt.vue?vue&type=script&lang=ts"
export * from "./summary-stt.vue?vue&type=script&lang=ts"

import "./summary-stt.vue?vue&type=style&index=0&id=00a07e5a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__